import { useParams, Link } from 'react-router-dom';
import { getCategoryById, getArticlesByCategory } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';
import Breadcrumb from '@/components/feature/Breadcrumb';
import NotFound from '@/pages/NotFound';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = getCategoryById(slug || '');
  const categoryArticles = slug ? getArticlesByCategory(slug) : [];

  if (!category) {
    return <NotFound />;
  }

  const pageTitle = `${category.name} - 夜勤病栋深度解析`;
  const pageDesc = `${category.description}。夜勤病栋${category.name}专题，共${categoryArticles.length}篇深度解析文章。`;

  return (
    <>
      <script type="application/ld+json">{JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: pageTitle,
        description: pageDesc,
        url: `https://jinglianwl.cn/category/${slug}`,
        inLanguage: 'zh-CN',
        isPartOf: {
          '@type': 'WebSite',
          name: '夜勤病栋解析站',
          url: 'https://jinglianwl.cn',
        },
      })}</script>

      <main className="pt-20 pb-16 bg-background-50">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="mb-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: category.name },
              ]}
            />
          </div>

          <div className="mb-10">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-lg bg-primary-500/15 flex items-center justify-center">
                <i className={`${category.icon} text-primary-400 text-lg`}></i>
              </div>
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">
                {category.name}
              </h1>
            </div>
            <p className="text-foreground-500 ml-13">{category.description}</p>
          </div>

          {categoryArticles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {categoryArticles.map((article) => (
                <ArticleCard key={article.id} article={article} variant="default" />
              ))}
            </div>
          ) : (
            <div className="text-center py-16">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-background-100 flex items-center justify-center">
                <i className="ri-inbox-line text-2xl text-foreground-500"></i>
              </div>
              <p className="text-foreground-500">该分类暂无文章</p>
            </div>
          )}

          <div className="mt-10 pt-6 border-t border-background-200/60">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-primary-400 transition-colors"
            >
              <i className="ri-arrow-left-line"></i>
              返回首页
            </Link>
          </div>
        </div>
      </main>
    </>
  );
}